import {CategoryDtoModel} from './category.dto.model';

export class AddressDtoModel {
    streetAddress?: string;
    city?: string;
    zipCode?: string;
    countryUuid?: string;
}

export class PartnerDtoModel {

    name?: string;
    imagePath?: string;
    qrCodePath?: string;
    websiteLink?: string;
    description?: string;
    keywords?: string[];
    heartStroke?: boolean;
    popular?: boolean;
    userName?: string;
    phoneNumber?: string;
    categoryName?: string;
    uuid?: string;
    mainCategorieUuid?: string;
    secondaryCategoriesUuids?: string[];
    tagUuid?: string;
    address = new AddressDtoModel();
    preferences?: string[];
    secondaryPreferences?: string[];
    oldId?: number;
    mainCategory: CategoryDtoModel;
    secondaryCategories: CategoryDtoModel[];
    draft?: boolean;
    emoji?: string;
}
